import * as THREE from 'three';
import FocusOnCmd from './FocusOnCmd';
import CommandIdEnum from '../enums/CommandIdEnums';
import CommandStack from '../logic/CommandStack';
import Document from '../model/document/Document';
import IParameterizable from '../interfaces/IParameterizable';
import { UUID } from '../utils/typeDefinitions';

export default class FocusOnSceneObjectCmd extends FocusOnCmd implements IParameterizable<UUID> {

    #document: Document;
    #sceneObjectUuid: UUID | undefined;

    constructor(commandStack: CommandStack, document: Document) {
        super(CommandIdEnum.FocusOnSceneObject, commandStack, 3);
        this.commandNameResourceKey = 'command.focusOnSceneObject.title';
        this.#document = document;
    }

    setParameters(uuid: UUID): void {
        this.#sceneObjectUuid = uuid;
    }

    protected findTargetObject(): THREE.Object3D | undefined {
        if (!this.#sceneObjectUuid) {
            console.error('FocusOnSceneObjectCmd: no scene object UUID set');
            return undefined;
        }

        const sceneObject = this.#document.getSceneObject(this.#sceneObjectUuid);
        if (!sceneObject) {
            console.error(`FocusOnSceneObjectCmd: scene object not found for UUID ${this.#sceneObjectUuid}`);
            return undefined;
        }

        return sceneObject.geometry.group;
    }
}

